import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

import {
  Wc as gender,
  School as competence,
  Person as person,
  MiscellaneousServices as cogwheels,
  Lock as lockBox,
  Notifications as notificationRounded,
  ViewColumn as column,
} from '@mui/icons-material';
import vendor from '@mui/icons-material/ThreePRounded'
import reorderRoundedIcon from '@mui/icons-material/DragHandleRounded';

import personal from '@mui/icons-material/PersonRounded';
import personalOutlined from '@mui/icons-material/PersonOutlineOutlined';
import group from '@mui/icons-material/GroupRounded';
import groupOutlined from '@mui/icons-material/GroupOutlined';
import check from '@mui/icons-material/Check';
import deleteOutlined from '@mui/icons-material/DeleteOutlineOutlined';
import highlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import paymentOutlined from '@mui/icons-material/PaymentOutlined';
import competenceOutlined from '@mui/icons-material/SchoolOutlined';
import vendorOutlined from '@mui/icons-material/ThreePOutlined';

export const excel = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path
      fill='currentColor'
      d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m1.8 18H14l-2-3.4l-2 3.4H8.2l2.9-4.5L8.2 11H10l2 3.4l2-3.4h1.8l-2.9 4.5l2.9 4.5M13 9V3.5L18.5 9H13Z'
    />
  </svg>,
  'excel'
);

export const cogwheel = createSvgIcon(
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_1_43473)'>
      <path
        d='M8.03061 2.62536C8.15295 2.76116 8.30246 2.86974 8.46944 2.94406C8.63643 3.01838 8.81717 3.05678 8.99995 3.05678C9.18272 3.05678 9.36346 3.01838 9.53045 2.94406C9.69744 2.86974 9.84694 2.76116 9.96928 2.62536L10.5999 1.93336C10.7807 1.73332 11.0189 1.59412 11.2819 1.53486C11.5449 1.47561 11.8198 1.4992 12.0689 1.60241C12.318 1.70562 12.529 1.88337 12.673 2.11129C12.817 2.3392 12.887 2.6061 12.8733 2.87536L12.8259 3.80869C12.8168 3.99076 12.8459 4.17273 12.9113 4.34288C12.9768 4.51303 13.0771 4.66758 13.2059 4.79658C13.3348 4.92558 13.4892 5.02617 13.6592 5.09187C13.8293 5.15756 14.0112 5.18691 14.1933 5.17802L15.1266 5.13069C15.3957 5.11742 15.6623 5.1877 15.8899 5.33188C16.1175 5.47607 16.2949 5.6871 16.3978 5.93607C16.5008 6.18503 16.5242 6.45974 16.4649 6.72254C16.4056 6.98535 16.2665 7.22338 16.0666 7.40402L15.3719 8.03069C15.2363 8.1532 15.1279 8.3028 15.0537 8.46983C14.9795 8.63685 14.9411 8.81759 14.9411 9.00036C14.9411 9.18313 14.9795 9.36386 15.0537 9.53089C15.1279 9.69791 15.2363 9.84751 15.3719 9.97002L16.0666 10.5967C16.2667 10.7774 16.4059 11.0157 16.4651 11.2787C16.5244 11.5417 16.5008 11.8166 16.3976 12.0657C16.2944 12.3147 16.1166 12.5257 15.8887 12.6698C15.6608 12.8138 15.3939 12.8837 15.1246 12.87L14.1913 12.8227C14.0088 12.8133 13.8264 12.8423 13.6558 12.9079C13.4853 12.9735 13.3304 13.0741 13.2012 13.2033C13.072 13.3325 12.9714 13.4874 12.9058 13.6579C12.8403 13.8285 12.8112 14.0109 12.8206 14.1934L12.8679 15.1267C12.8799 15.3946 12.8091 15.6597 12.6651 15.8859C12.5211 16.1122 12.311 16.2886 12.0633 16.3913C11.8155 16.494 11.5422 16.5179 11.2804 16.4598C11.0186 16.4018 10.781 16.2645 10.5999 16.0667L9.97261 15.3727C9.85016 15.2371 9.70062 15.1287 9.53365 15.0545C9.36668 14.9803 9.186 14.9419 9.00328 14.9419C8.82056 14.9419 8.63988 14.9803 8.47291 15.0545C8.30594 15.1287 8.1564 15.2371 8.03395 15.3727L7.40395 16.0667C7.22315 16.2654 6.98547 16.4035 6.72331 16.4623C6.46115 16.521 6.18725 16.4974 5.93898 16.3948C5.6907 16.2921 5.48011 16.1154 5.33593 15.8887C5.19174 15.662 5.12098 15.3964 5.13328 15.128L5.18128 14.1947C5.19067 14.0122 5.16164 13.8298 5.09608 13.6593C5.03051 13.4887 4.92988 13.3338 4.80068 13.2046C4.67148 13.0754 4.5166 12.9748 4.34605 12.9092C4.1755 12.8437 3.99309 12.8146 3.81061 12.824L2.87728 12.8714C2.60814 12.8854 2.34124 12.8158 2.11324 12.6721C1.88524 12.5284 1.7073 12.3176 1.60387 12.0688C1.50043 11.8199 1.47657 11.5451 1.53555 11.2821C1.59453 11.0192 1.73346 10.7809 1.93328 10.6L2.62728 9.97336C2.76291 9.85085 2.87133 9.70125 2.94554 9.53422C3.01975 9.3672 3.05809 9.18646 3.05809 9.00369C3.05809 8.82092 3.01975 8.64019 2.94554 8.47316C2.87133 8.30613 2.76291 8.15653 2.62728 8.03402L1.93328 7.40402C1.73411 7.22336 1.5956 6.98559 1.53668 6.72323C1.47776 6.46086 1.5013 6.1867 1.60409 5.93822C1.70689 5.68974 1.88391 5.47907 2.11096 5.33501C2.33801 5.19095 2.60402 5.12052 2.87261 5.13336L3.80595 5.18069C3.98877 5.1903 4.17156 5.16135 4.34246 5.09572C4.51337 5.03008 4.66855 4.92923 4.79794 4.79972C4.92733 4.67021 5.02803 4.51492 5.09349 4.34396C5.15896 4.17299 5.18774 3.99017 5.17795 3.80736L5.13328 2.87336C5.12068 2.60487 5.19124 2.33903 5.33531 2.11212C5.47938 1.88521 5.68996 1.70827 5.93831 1.60547C6.18665 1.50266 6.46067 1.47898 6.72297 1.53766C6.98527 1.59634 7.22308 1.73452 7.40395 1.93336L8.03061 2.62536Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6 9.00073C6 9.79638 6.31607 10.5594 6.87868 11.1221C7.44129 11.6847 8.20435 12.0007 9 12.0007C9.79565 12.0007 10.5587 11.6847 11.1213 11.1221C11.6839 10.5594 12 9.79638 12 9.00073C12 8.20508 11.6839 7.44202 11.1213 6.87941C10.5587 6.3168 9.79565 6.00073 9 6.00073C8.20435 6.00073 7.44129 6.3168 6.87868 6.87941C6.31607 7.44202 6 8.20508 6 9.00073V9.00073Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_43473'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </svg>,
  'cogwheel'
);

export const question = createSvgIcon(
  <svg
    width='17'
    height='17'
    viewBox='0 0 17 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.31822 6.06808C5.31815 6.48229 5.65387 6.81814 6.06808 6.81822C6.4823 6.8183 6.81815 6.48258 6.81822 6.06836L5.31822 6.06808ZM8.64676 7.89189L8.89676 8.59899L8.64676 7.89189ZM8.00212 8.80404H8.75212V8.80365L8.00212 8.80404ZM7.25212 9.45255C7.25212 9.86676 7.58791 10.2025 8.00212 10.2025C8.41634 10.2025 8.75212 9.86676 8.75212 9.45255H7.25212ZM7.97952 10.9043C7.56531 10.9043 7.22952 11.2401 7.22952 11.6543C7.22952 12.0685 7.56531 12.4043 7.97952 12.4043V10.9043ZM8.00212 12.4043C8.41634 12.4043 8.75212 12.0685 8.75212 11.6543C8.75212 11.2401 8.41634 10.9043 8.00212 10.9043V12.4043ZM14.5042 8.00212C14.5042 11.5931 11.5931 14.5042 8.00212 14.5042V16.0042C12.4216 16.0042 16.0042 12.4216 16.0042 8.00212H14.5042ZM8.00212 14.5042C4.4111 14.5042 1.5 11.5931 1.5 8.00212H0C0 12.4216 3.58267 16.0042 8.00212 16.0042V14.5042ZM1.5 8.00212C1.5 4.4111 4.4111 1.5 8.00212 1.5V0C3.58267 0 0 3.58267 0 8.00212H1.5ZM8.00212 1.5C11.5931 1.5 14.5042 4.4111 14.5042 8.00212H16.0042C16.0042 3.58267 12.4216 0 8.00212 0V1.5ZM6.81822 6.06836C6.81827 5.85133 6.87797 5.63848 6.99081 5.45308L5.70947 4.67322C5.45366 5.09352 5.31832 5.57605 5.31822 6.06808L6.81822 6.06836ZM6.99081 5.45308C7.10364 5.26768 7.26528 5.11687 7.45804 5.01712L6.76867 3.68491C6.33169 3.91103 5.96527 4.25293 5.70947 4.67322L6.99081 5.45308ZM7.45804 5.01712C7.6508 4.91738 7.86726 4.87254 8.08378 4.88751L8.18725 3.39108C7.6964 3.35714 7.20566 3.45879 6.76867 3.68491L7.45804 5.01712ZM8.08378 4.88751C8.3003 4.90248 8.50854 4.97668 8.68574 5.102L9.55188 3.87734C9.15018 3.59323 8.6781 3.42502 8.18725 3.39108L8.08378 4.88751ZM8.68574 5.102C8.86294 5.22733 9.00228 5.39895 9.08853 5.59811L10.465 5.00202C10.2695 4.55052 9.95359 4.16145 9.55188 3.87734L8.68574 5.102ZM9.08853 5.59811C9.17478 5.79728 9.20462 6.01632 9.17479 6.2313L10.6606 6.43745C10.7282 5.95009 10.6605 5.45353 10.465 5.00202L9.08853 5.59811ZM9.17479 6.2313C9.14496 6.44628 9.05661 6.64892 8.9194 6.81707L10.0816 7.7654C10.3926 7.38419 10.5929 6.9248 10.6606 6.43745L9.17479 6.2313ZM8.9194 6.81707C8.78218 6.98523 8.60138 7.11243 8.39676 7.18478L8.89676 8.59899C9.36064 8.43499 9.77052 8.14662 10.0816 7.7654L8.9194 6.81707ZM8.39676 7.18478C8.06186 7.30318 7.77193 7.52254 7.56693 7.81262L8.7919 8.67833C8.81781 8.64167 8.85444 8.61396 8.89676 8.59899L8.39676 7.18478ZM7.56693 7.81262C7.36193 8.1027 7.25194 8.44923 7.25212 8.80444L8.75212 8.80365C8.7521 8.75877 8.766 8.71498 8.7919 8.67833L7.56693 7.81262ZM7.25212 8.80404V9.45255H8.75212V8.80404H7.25212ZM7.97952 12.4043H8.00212V10.9043H7.97952V12.4043Z'
      fill='currentColor'
    />
  </svg>,
  'question'
);

export const speechBubble = createSvgIcon(
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.5 13H8.5L4.5 16V13H2.5C2.23478 13 1.98043 12.8946 1.79289 12.7071C1.60536 12.5196 1.5 12.2652 1.5 12V2C1.5 1.73478 1.60536 1.48043 1.79289 1.29289C1.98043 1.10536 2.23478 1 2.5 1H15.5C15.7652 1 16.0196 1.10536 16.2071 1.29289C16.3946 1.48043 16.5 1.73478 16.5 2V12C16.5 12.2652 16.3946 12.5196 16.2071 12.7071C16.0196 12.8946 15.7652 13 15.5 13Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4.5 5.5H13.5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4.5 8.5H11.5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'speechBubble'
);

export const headset = createSvgIcon(
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_1_43489)'>
      <path
        d='M11 15.5H12.5C13.0304 15.5 13.5391 15.2893 13.9142 14.9142C14.2893 14.5391 14.5 14.0304 14.5 13.5V13'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 16.5H9C8.73478 16.5 8.48043 16.3946 8.29289 16.2071C8.10536 16.0196 8 15.7652 8 15.5C8 15.2348 8.10536 14.9804 8.29289 14.7929C8.48043 14.6054 8.73478 14.5 9 14.5H10C10.2652 14.5 10.5196 14.6054 10.7071 14.7929C10.8946 14.9804 11 15.2348 11 15.5C11 15.7652 10.8946 16.0196 10.7071 16.2071C10.5196 16.3946 10.2652 16.5 10 16.5Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4 13H3.5C2.96957 13 2.46086 12.7893 2.08579 12.4142C1.71071 12.0391 1.5 11.5304 1.5 11V9C1.5 8.46957 1.71071 7.96086 2.08579 7.58579C2.46086 7.21071 2.96957 7 3.5 7H4C4.13261 7 4.25979 7.05268 4.35355 7.14645C4.44732 7.24022 4.5 7.36739 4.5 7.5V12.5C4.5 12.6326 4.44732 12.7598 4.35355 12.8536C4.25979 12.9473 4.13261 13 4 13Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.5 13H14C13.8674 13 13.7402 12.9473 13.6464 12.8536C13.5527 12.7598 13.5 12.6326 13.5 12.5V7.5C13.5 7.36739 13.5527 7.24022 13.6464 7.14645C13.7402 7.05268 13.8674 7 14 7H14.5C15.0304 7 15.5391 7.21071 15.9142 7.58579C16.2893 7.96086 16.5 8.46957 16.5 9V11C16.5 11.5304 16.2893 12.0391 15.9142 12.4142C15.5391 12.7893 15.0304 13 14.5 13Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.5 7C3.5 5.54131 4.07946 4.14236 5.11091 3.11091C6.14236 2.07946 7.54131 1.5 9 1.5V1.5C10.4587 1.5 11.8576 2.07946 12.8891 3.11091C13.9205 4.14236 14.5 5.54131 14.5 7'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_43489'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </svg>,
  'headset'
);

export {
  column,
  cogwheels,
  competence,
  competenceOutlined,
  gender,
  vendor,
  vendorOutlined,
  person,
  lockBox,
  notificationRounded,
  group,
  groupOutlined,
  personal,
  personalOutlined,
  check,
  reorderRoundedIcon,
  deleteOutlined,
  highlightOffRoundedIcon,
  paymentOutlined,
};
